import interceptor from '../common/interceptor';
import { APIPaths } from '../common/constants';
import { AIHistoryRecord, ChartDataItem } from '@/pages/AiHistory/type';
import type { GetAIStateCountsRes } from '@/pages/AiHistory/AIHistoryPage';
import { FiltersPayload } from '@/pages/Data/types';
import { OperationType } from '@/common/enum';
import type { HistoryPayload } from '@/pages/AiHistory/utils/buildHistoryPayload';
export interface AiHistoryMassActionsPayload {
  alert_ids: string[];
  event_ids: string[];
  is_resolved: boolean;
}

export const aiHistoryMassActions = (
  token: string,
  model: AiHistoryMassActionsPayload
) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost('Post', APIPaths.ai_history_mass_actions, model, token)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log('error?.response?.data?.error', error?.response);
        reject(error?.response);
      });
  });
};
export interface GetAiHistoryKpiRes {
  data?: {
    data?: {
      is_success: boolean;
      message: string;
      page_count: number;
      total_count: number;

      data: ChartDataItem[];
    };
  };
}
// get ai hostory KPI data
export const GetHistoryKPI = (
  token: string,
  model: HistoryPayload
): Promise<GetAiHistoryKpiRes> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost(
        'Post',
        APIPaths.ai_history + 'stats/',
        model,
        token,
        null,
        OperationType.Read
      )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log('Error while fething ai history KPI:', error?.response);
        reject(error?.response);
      });
  });
};

export const GetAIStateCounts = (
  token: string,
  model: Record<string, unknown> = {}
): Promise<GetAIStateCountsRes> => {
  return interceptor
    .axiosPost(
      'Post',
      APIPaths.ai_history_counts,
      model,
      token,
      null,
      OperationType.Read
    )
    .then((res) => res.data)
    .catch((error) => {
      console.log('Error while fetching ai state:', error?.response);
      throw error?.response;
    });
};

interface GetAiHistoryWithPaginationAndSearchResponse {
  data?: {
    data?: {
      is_success: boolean;
      message: string;
      page_count: number;
      total_count: number;
      timezone_abbr?: string | null;

      data: AIHistoryRecord[];
    };
  };
}

// API call for Get ai history table data
export const GetAiHistoryWithPaginationAndSearch = (
  token: string,
  body: FiltersPayload & {
    page?: number;
    page_size?: number;
    preset_id?: string;
    search?: string;
  }
): Promise<GetAiHistoryWithPaginationAndSearchResponse> => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost(
        'Post',
        APIPaths.ai_history,
        body,
        token,
        null,
        OperationType.Read
      )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log('Error while fething ai history data:', error?.response);
        reject(error?.response);
      });
  });
};

// export const GetAiHistoryWithPaginationAndSearch = (
//   token: string,
//   page?: number,
//   search?: string
// ): Promise<GetAiHistoryWithPaginationAndSearchResponse> => {
//   const params = new URLSearchParams();
//   if (page != null) {
//     params.append('page', page.toString());
//   }

//   if (search) {
//     params.append('search', search);
//   }

//   const url = `${APIPaths.ai_history}?${params.toString()}`;

//   return new Promise((resolve, reject) => {
//     interceptor
//       .axiosGet('Get', url, token, null)
//       .then((res) => resolve(res))
//       .catch((error) => {
//         console.log('error?.response?.data?.error', error?.response);
//         reject(error?.response);
//       });
//   });
// };
